import { Component, isDevMode, OnInit } from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {Observable} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import {Router} from "@angular/router";
import {DatePipe} from "@angular/common";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {EducationService} from "../../../education/education.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {LogService} from "../../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {EmployeeService} from "../../../../services/employee.service";
import firebase from "firebase/compat";
import {ChildService} from "../../../../components/child/child.service";

export interface SessionCount {
  srNo: number;
  centreName: string;

  newIndividual: number;
  newGroup: number;
  newAssessment: number;

  followIndividual: number;
  followGroup: number;
  followAssessment: number;

  date?: string; // optional date for filtering
}

const ELEMENT_DATA: SessionCount[] = [];

@Component({
  selector: 'app-session-count-report',
  templateUrl: './session-count-report.component.html',
  styleUrls: ['./session-count-report.component.scss']
})
export class SessionCountReportComponent implements OnInit {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  fullData = ELEMENT_DATA; // original data for filtering
  dataSource = new MatTableDataSource<SessionCount>(ELEMENT_DATA);
  dashboardData: any[] = [];
  dashboardSource = new MatTableDataSource<any>([]);
  startDate!: Date;
  endDate!: Date;
  selectedCentre: any[] = [];
  centres$: Observable<Centre[]>
  headerRow1 = [
    'srNo',
    'centreName',
    'newHeader',
    'followHeader'
  ];

  headerRow2 = [
    'newIndividual',
    'newGroup',
    'newAssessment',
    'followIndividual',
    'followGroup',
    'followAssessment'
  ];

  displayedColumns = [
    'srNo',
    'centreName',
    'newIndividual',
    'newGroup',
    'newAssessment',
    'followIndividual',
    'followGroup',
    'followAssessment'
  ];

  // ----------------
  dashboardColumns = [
    'srNo',
    'centreName',
    'admission',
    'discharge',
    'followup'
  ];
  private sessionGrouped: { [centre: string]: SessionCount } = {};
  constructor(private mCentreService : CentreService,
              private  readonly mFirestore:AngularFirestore) {
    this.centres$ = this.mCentreService.getAllCentres()
  }

  ngOnInit(): void {
  }
  private chunkArray<T>(array: T[], size: number): T[][] {
    const result: T[][] = [];

    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }

    return result;
  }

  private async getChildrenMap(childCodes: string[]): Promise<Map<string, boolean>> {

    const chunks = this.chunkArray(childCodes, 10);
    const childMap = new Map<string, boolean>();

    const promises = chunks.map(chunk => {
      return this.mFirestore.firestore
        .collection(this.env.child)
        .where('childCode', 'in', chunk)
        .get();
    });

    const snapshots = await Promise.all(promises);

    snapshots.forEach(snapshot => {
      snapshot.docs.forEach(doc => {
        const data: any = doc.data();
        const isFollowUp = (data.admissionData?.length || 0) > 2;
        childMap.set(data.childCode, isFollowUp);
      });
    });

    return childMap;
  }
  async searchByDateAndCentre() {

    if (!this.selectedCentre?.length) return;

    const centreCodes = this.selectedCentre.map(c => c.centreCode);

    const sessions = await this.getIndividualSessions(
      centreCodes,
      this.startDate,
      this.endDate
    );

    this.generateDashboard(sessions);

  }

  generateDashboard(sessions:any[]) {

    const grouped:any = {};

    sessions.forEach(session => {

      const centre = session.centreName || 'Unknown';

      if(!grouped[centre]){

        grouped[centre] = {
          centreName: centre,
          admission: 0,
          regular: 0,
          discharge: 0,
          followup: 0
        };

      }

      switch(session.type){

        case 'Admission Rapport building counselling':
          grouped[centre].admission++;
          break;

        case 'Regular Counselling':
          grouped[centre].regular++;
          break;

        case 'Discharge Counselling':
          grouped[centre].discharge++;
          break;

        case 'Follow-up Counselling':
          grouped[centre].followup++;
          break;

      }

    });

    this.dashboardData = Object.values(grouped);

    this.dashboardSource.data = this.dashboardData;

  }

  async searchByDateAndCentre2() {
    if (!this.selectedCentre?.length) return;
    const centreCodes = this.selectedCentre.map(c => c.centreCode);
    this.sessionGrouped = {};
    const [individual, group, assessment] = await Promise.all([
      this.getIndividualSessions(centreCodes, this.startDate, this.endDate),
      this.getGroupSessions(centreCodes, this.startDate, this.endDate),
      this.getCounselingFollowUpAssessment(centreCodes, this.startDate, this.endDate)
    ]);
    const allChildCodes = [
      ...individual,
      ...group,
      ...assessment
    ]
      .map(item => item.childCode)
      .filter(code => !!code);

    const uniqueChildCodes = [...new Set(allChildCodes)];
    const childMap = await this.getChildrenMap(uniqueChildCodes);
    this.processIndividualData(individual, childMap);
    this.processGroupData(group, childMap);
    this.processAssessmentData(assessment, childMap);
    this.updateTable();
  }
  async getCounselingFollowUpAssessment(
    centreCodes: string[],
    startDate?: Date,
    endDate?: Date
  ): Promise<any[]> {

    const baseQuery = this.mFirestore.firestore
      .collection(this.env.counsellingFollowUp);

    return this.executeChunkedQuery(baseQuery, centreCodes, startDate, endDate);
  }
  processAssessmentData(data: any[], childMap: Map<string, boolean>) {
    data.forEach(item => {
      const centre = item.centreName || 'Unknown';
      const isFollowUp = childMap.get(item.childCode);

      if (!this.sessionGrouped[centre]) {
        this.sessionGrouped[centre] = this.createEmptyCentre(centre);
      }

      if (isFollowUp) {
        this.sessionGrouped[centre].followAssessment++;
      } else {
        this.sessionGrouped[centre].newAssessment++;
      }

    });
  }
  async getIndividualSessions(
    centreCodes: string[],
    startDate?: Date,
    endDate?: Date
  ): Promise<any[]> {

    const baseQuery = this.mFirestore.firestore
      .collection(this.env.counseling)
      .doc('allSessions')
      .collection('sessions');

    return this.executeChunkedQuery(baseQuery, centreCodes, startDate, endDate);
  }
  processIndividualData(data: any[], childMap: Map<string, boolean>) {

    data.forEach(item => {

      const centre = item.centreName || 'Unknown';
      const isFollowUp = childMap.get(item.childCode);

      if (!this.sessionGrouped[centre]) {
        this.sessionGrouped[centre] = this.createEmptyCentre(centre);
      }

      if (isFollowUp) {
        this.sessionGrouped[centre].followIndividual++;
      } else {
        this.sessionGrouped[centre].newIndividual++;
      }

    });
  }
  async getGroupSessions(
    centreCodes: string[],
    startDate?: Date,
    endDate?: Date
  ): Promise<any[]> {

    const baseQuery = this.mFirestore.firestore
      .collection(this.env.counseling)
      .doc('allSessions')
      .collection('groupSessions');

    return this.executeChunkedQuery(baseQuery, centreCodes, startDate, endDate);
  }
  processGroupData(data: any[], childMap: Map<string, boolean>) {

    data.forEach(item => {

      const centre = item.centreName || 'Unknown';
      const isFollowUp = childMap.get(item.childCode);

      if (!this.sessionGrouped[centre]) {
        this.sessionGrouped[centre] = this.createEmptyCentre(centre);
      }

      if (isFollowUp) {
        this.sessionGrouped[centre].followGroup++;
      } else {
        this.sessionGrouped[centre].newGroup++;
      }

    });
  }
  // Clear Filters
  clearAllFilters() {
    this.startDate = null!;
    this.endDate = null!;
    this.selectedCentre = [];
    this.dataSource.data = this.fullData;
  }

  createEmptyCentre(centre: string): SessionCount {
    return {
      srNo: Object.keys(this.sessionGrouped).length + 1,
      centreName: centre,

      newIndividual: 0,
      newGroup: 0,
      newAssessment: 0,

      followIndividual: 0,
      followGroup: 0,
      followAssessment: 0
    };
  }
  updateTable() {
    this.dataSource.data = Object.values(this.sessionGrouped);
  }

  displayCentre(c: any) {
    return c?.centreName || '';
  }


  onCentreSelect(selectedCentres: Centre | Centre[]) {
    if (!selectedCentres) {
      this.selectedCentre = [];
      return;
    }
    // Normalize to array of objects
    const centresArray = Array.isArray(selectedCentres) ? selectedCentres : [selectedCentres];
    // Extract only valid centreCodes
    this.selectedCentre = centresArray.filter(c => c && c.centreCode)  // skip undefined.map(c => c.centreCode);
    console.log("Selected Centre Codes:", this.selectedCentre);
  }
  private async executeChunkedQuery(
    baseQuery: firebase.firestore.Query,
    centreCodes: string[],
    startDate?: Date,
    endDate?: Date
  ): Promise<any[]> {

    const chunks = this.chunkArray(centreCodes, 10);
    let allResults: any[] = [];

    const promises = chunks.map(chunk => {

      let query = baseQuery.where('centreCode', 'in', chunk);

      if (startDate && endDate) {
        const start = new Date(startDate);
        start.setHours(0,0,0,0);

        const end = new Date(endDate);
        end.setHours(23,59,59,999);

        query = query
          .where('date', '>=', start)
          .where('date', '<=', end);
      }

      return query.get();
    });

    const snapshots = await Promise.all(promises);

    snapshots.forEach(snapshot => {
      allResults.push(...snapshot.docs.map(doc => doc.data()));
    });

    return allResults;
  }
  formatZero(value: number): string | number {
    return value === 0 ? '-' : value;
  }
}
